import { PublicUserGq, PublicUserGqProps } from './PublicUserGq';
import { CurrentTeamGq, CurrentTeamGqProps } from './CurrentTeamGq';
import { UserTeamRoleGq } from './UserTeamRoleGq';

export interface CurrentUserGq {
  id: number;
  email: string;
  name?: string;
  picture?: string;
  givenName?: string;
  familyName?: string;

  invitedTime?: string;
  firstSignInTime?: string;
  inviteAccepted?: boolean;
  invitedBy?: PublicUserGq;

  team: CurrentTeamGq;
  teamRole: UserTeamRoleGq;

  defaultPaletteId?: number;
  defaultLanguageId?: number;
  defaultLocationId?: number;
  defaultCurrency: string;
  projectSubscriptions?: number[];

  deletedTime?: string;
  deletedBy?: PublicUserGq;

  accessUserCanCreatePalette: boolean;
  accessUserCanCreateProject: boolean;
}

export const CurrentUserGqProps = `
  id
  email
  name
  givenName
  familyName
  picture
  invitedTime
  firstSignInTime
  inviteAccepted
  invitedBy { ${PublicUserGqProps} }
  
  team { ${CurrentTeamGqProps} }
  teamRole

  defaultPaletteId
  defaultLocationId
  defaultLanguageId
  defaultCurrency
  projectSubscriptions

  deletedTime
  deletedBy { ${PublicUserGqProps} }

  accessUserCanCreatePalette
  accessUserCanCreateProject
`;
